import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getListObligacion = () => {
    return axios.get(`/api/Obligacion/obligacion/list`, { headers: authHeaderJson() } );
};

const getObligacion = (obligacion_id) => {
    return axios.get(`/api/Obligacion/obligacion/${obligacion_id}`, { headers: authHeaderJson() } );
};

const getListCategoriaObligacion = () => {
    return axios.get(`/api/Obligacion/obligacion/categoria/list`, { headers: authHeaderJson() } );
};

const getListRolesByCategory = (categoria_id) => {
    return axios.get(`/api/Obligacion/obligacion/rol/categoria/list/${categoria_id}`, { headers: authHeaderJson() } );
};

const getCategoriaObligacion = (categoria_id) => {
    return axios.get(`/api/Obligacion/obligacion/categoria/${categoria_id}`, { headers: authHeaderJson() } );
};

const updateObligacion = (obligacion_id, item) => {
    return axios.put(`/api/Obligacion/obligacion/update/${obligacion_id}`, item, { headers: authHeaderJson() });
};

const setObligacion = (item) => {
    return axios.post(`/api/Obligacion/obligacion/add`, item, { headers: authHeaderJson() } )
};

const setCategoriaObligacion = (item) => {
    return axios.post(`/api/Obligacion/obligacion/categoria/add`, item, { headers: authHeaderJson() } )
};

const setbligacionList = (itemList) => {
    return axios.post(`/api/Obligacion/obligacion/add/list`, itemList, { headers: authHeaderJson() } )
};

const setCategoriaObligacionList = (itemList) => {
    return axios.post(`/api/Obligacion/obligacion/categoria/add/list`, itemList, { headers: authHeaderJson() } )
};

const updateCategoriaObligacion = (categoria_id, item) => {
    return axios.put(`/api/Obligacion/obligacion/categoria/update/${categoria_id}`, item, { headers: authHeaderJson() });
};

const deleteObligacion = (obligacion_id) => {
    return axios.delete(`/api/Obligacion/obligacion/delete/${obligacion_id}`, { headers: authHeaderJson() });
};

const deleteCategoriaObligacion = (categoria_id) => {
    return axios.delete(`/api/Obligacion/obligacion/categoria/delete/${categoria_id}`, { headers: authHeaderJson() });
};

const getObligationSubLegalEntities = (obligacion_id) => {
    return axios.get(`/api/Obligacion/obligacion/legalentity/list/${obligacion_id}`, { headers: authHeaderJson() });
};

const setObligationSubLegalEntities = (obligacion_id, itemList) => {
    return axios.post(`/api/Obligacion/obligacion/legalentity/add/list/${obligacion_id}`, itemList, { headers: authHeaderJson() });
};

// Pantalla "Contratos / Obligaciones incongruentes": lista, vista previa (no cambia nada) y aplicación de una acción sobre un conjunto de filas.
const getListObligationInconsistencies = () => {
    return axios.get(`/api/Obligacion/obligacion/incongruencia/list`, { headers: authHeaderJson() });
};

const previewObligationInconsistencyAction = (action) => {
    return axios.post(`/api/Obligacion/obligacion/incongruencia/preview`, action, { headers: authHeaderJson() });
};

const applyObligationInconsistencyAction = (action) => {
    return axios.post(`/api/Obligacion/obligacion/incongruencia/apply`, action, { headers: authHeaderJson() });
};

export {
    getListObligationInconsistencies,
    previewObligationInconsistencyAction,
    applyObligationInconsistencyAction,
    getListObligacion,
    getObligacion,
    getListCategoriaObligacion,
    getCategoriaObligacion,
    updateObligacion,
    setObligacion,
    setCategoriaObligacion,
    updateCategoriaObligacion,
    setbligacionList,
    setCategoriaObligacionList,
    deleteObligacion,
    deleteCategoriaObligacion,
    getListRolesByCategory,
    getObligationSubLegalEntities,
    setObligationSubLegalEntities,
}